import React, { useState, useEffect } from 'react';
import {
	IItemForGetShortInfo,
	IGetModifierGroupsShortResponse,
	IGetModifierGroupsShort,
	ITotalPrice,
	IDishModifierGroup,
} from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getModifierGroupsShortInfo } from 'backend/modifierGroups';
import MultipleSelect from './components/MultipleSelect';
import style from './ModifierGroupsMultipleSelect.module.scss';

interface IModifierGroupsMultipleSelect {
	setFetchedModifierGroups: (value: IItemForGetShortInfo[]) => void;
	totalPrices: ITotalPrice[];
	setModifierGroups: (value: string[]) => void;
	selectedModifierGroups: string[];
	initialModifierGroups: IDishModifierGroup[];
}

const ModifierGroupsMultipleSelect: React.FC<IModifierGroupsMultipleSelect> = ({
	selectedModifierGroups,
	totalPrices,
	setModifierGroups,
	setFetchedModifierGroups,
	initialModifierGroups,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<
		IGetModifierGroupsShortResponse,
		IGetModifierGroupsShort
	>(totalPrices.length ? getModifierGroupsShortInfo : null, {
		restaurantIds: totalPrices.map((el) => el.restaurantId),
	});
	const [isFirstRender, setIsFirstRender] = useState<boolean>(true);

	useEffect(() => {
		refetch();
	}, [totalPrices]);

	useEffect(() => {
		if (response) {
			setFetchedModifierGroups(response.data.modifierGroups);
		}
		if (isFirstRender && response) {
			setModifierGroups(initialModifierGroups.map((el) => el.modifierGroupId));
			setIsFirstRender(false);
		}
	}, [response]);

	return (
		<div className={style.container}>
			<div className={style.field}>
				<MultipleSelect
					data={response?.data.modifierGroups || []}
					isLoading={loading}
					refetch={refetch}
					responseError={responseError}
					selectedModifierGroups={selectedModifierGroups}
					totalPrices={totalPrices}
					setModifierGroups={setModifierGroups}
				/>
			</div>
		</div>
	);
};

export default React.memo(ModifierGroupsMultipleSelect);
